module.exports = __webpack_public_path__ + "3847224a806dc812dd4605da298d9512.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-17.png
// module id = 1494
// module chunks = 0